export default __webpack_public_path__ + "8bf0bb61209b25710c1d7bd25b5d3ee5.png";